module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/jszip/~/core-js/library/modules/_fails.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_fails.js
// module chunks = 3